// :::tryit inbound prefill: validate a WebOS-parent postMessage and sanitize the
// command before it lands at the prompt. Pure (no DOM/network) so the security
// predicate is unit-testable. Spec 7.5.

const MAX_TRYIT_COMMAND_LEN = 2000;

// Blocked code-point ranges: C0, DEL+C1, bidi/format overrides. Removes CR/LF
// (would execute), ESC/CSI (control sequences), and display-spoofing chars so the
// command lands as inert editable text.
const BLOCKED_RANGES = [[0x00, 0x1f], [0x7f, 0x9f], [0x202a, 0x202e], [0x2066, 0x2069]];

function stripControlChars(s) {
  let out = '';
  for (const ch of s) {
    const cp = ch.codePointAt(0);
    if (!BLOCKED_RANGES.some(([lo, hi]) => cp >= lo && cp <= hi)) out += ch;
  }
  return out;
}

function sanitizeTryitCommand(command) {
  if (typeof command !== 'string') return null;
  const stripped = stripControlChars(command);
  if (stripped.length === 0 || stripped.length > MAX_TRYIT_COMMAND_LEN) return null;
  return stripped;
}

// Accept only upslash:tryit:prefill from the pinned WebOS origin. event.origin is
// browser-set/unforgeable, so a match proves the WebOS parent sent it.
function isTrustedPrefillMessage(event, webosOrigin) {
  if (!event || event.data == null || typeof event.data !== 'object') return false;
  if (event.data.type !== 'upslash:tryit:prefill') return false;
  if (!webosOrigin || event.origin !== webosOrigin) return false;
  return true;
}

module.exports = { MAX_TRYIT_COMMAND_LEN, sanitizeTryitCommand, isTrustedPrefillMessage };
